import React from 'react';
import { useNavigate } from 'react-router-dom';

const HOME_IMG = '/home-icon.png';
const BACK_IMG = 'https://customer-assets.emergentagent.com/job_space-rental-hub-3/artifacts/2jaudnr2_image.png';

export const HomeButton = ({ className = '' }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/buyer')}
      className={`shrink-0 hover:scale-110 active:scale-95 transition-transform ${className}`}
      data-testid="nav-home-btn"
      title="Go to home"
    >
      <img src={HOME_IMG} alt="Home" className="w-9 h-9 rounded-full object-cover drop-shadow-md" />
    </button>
  );
};

export const BackButton = ({ className = '' }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className={`shrink-0 hover:scale-110 active:scale-95 transition-transform ${className}`}
      data-testid="nav-back-btn"
      title="Go back"
    >
      <img src={BACK_IMG} alt="Back" className="w-9 h-9 rounded-full object-cover drop-shadow-md" />
    </button>
  );
};
